import { render, staticRenderFns } from "./BoardDetail.vue?vue&type=template&id=c27b6ec0&scoped=true&"
import script from "./BoardDetail.vue?vue&type=script&lang=ts&"
export * from "./BoardDetail.vue?vue&type=script&lang=ts&"
import style0 from "./BoardDetail.vue?vue&type=style&index=0&id=c27b6ec0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27b6ec0",
  null
  
)

export default component.exports